import React, {Fragment} from 'react';
import {Link} from "react-router-dom";
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import {People, GroupWork, HelpOutline, ExitToApp, FitnessCenter, WatchLaterOutlined} from '@material-ui/icons';
import logo from './logo.png';
import {withNamespaces} from 'react-i18next';
import './Sidebar.css';

const packageJson = require('../../../../package.json');

const Sidebar = (props) => {
    const {t} = props;

    const user = JSON.parse(localStorage.getItem('user'));

    return (
        <Fragment>
            <img src={logo} alt="PowerGym" className="logo"/>
            <List>
                {user && user.level > 0 &&
                <>
                    <ListItem button component={Link} key="login" to="/current-bookings" onClick={props.handleDrawerToggle}>
                        <ListItemIcon><WatchLaterOutlined/></ListItemIcon>
                        <ListItemText primary={t("Current Bookings")}/>
                    </ListItem>
                    <Divider/>
                </>}

                <ListItem button component={Link} key="homepage" to="/" onClick={props.handleDrawerToggle}>
                    <ListItemIcon><GroupWork/></ListItemIcon>
                    <ListItemText primary={t("Home")}/>
                </ListItem>
                <ListItem button component={Link} key="my-bookings" to="/my-bookings"
                          onClick={props.handleDrawerToggle}>
                    <ListItemIcon><People/></ListItemIcon>
                    <ListItemText primary={t("My Bookings")} />
                </ListItem>
                <ListItem button component={Link} key="routine" to="/routine" onClick={props.handleDrawerToggle}>
                    <ListItemIcon><FitnessCenter/></ListItemIcon>
                    <ListItemText primary={t("My Routine")} />
                </ListItem>
                <ListItem button component={Link} key="about" to="/about" onClick={props.handleDrawerToggle}>
                    <ListItemIcon><HelpOutline/></ListItemIcon>
                    <ListItemText primary={t("About")} />
                </ListItem>

                <Divider/>
                <ListItem button component={Link} key="login" to="/login" onClick={props.handleDrawerToggle}>
                    <ListItemIcon><ExitToApp/></ListItemIcon>
                    <ListItemText primary={t("Logout")}/>
                </ListItem>
                <Divider/>
            </List>
            <p className="version">v{packageJson.version}</p>
        </Fragment>
    );
};


export default withNamespaces()(Sidebar);
